import { StatModule } from "@/core/modules/stat/objects/StatModule";

import StockChartView from "./views/StockChartView.vue";

export const stockChart: StatModule = new StatModule("warehouse", "StockChart", "warehouseStat", StockChartView);
